import {getBottomSpace} from 'react-native-iphone-screen-helper';
import {RFPercentage, RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import Feather from 'react-native-vector-icons/Feather';
import {Platform} from 'react-native';
import FastImage from '../../components/Interface/Images/FastImageWithFallback';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const Header = styled.View`
  height: ${RFPercentage(25)}px;
  background-color: ${({theme}) => theme.colors.red_light};
  justify-content: flex-end;
`;

//@ts-ignore
export const HeaderImage = styled(FastImage)`
  height: 100%;
  width: 100%;
`;

export const Content = styled.View`
  padding: 0 24px;
  flex: 1;

  background-color: ${({theme}) => theme.colors.background};
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  padding-top: ${RFValue(16)}px;
  margin-top: -${RFPercentage(5)}px;
`;

export const ContentHeaderIcon = styled.View`
  justify-content: center;
  align-items: center;
`;

export const IconContainer = styled.View`
  width: ${RFValue(50)}px;
  height: ${RFValue(50)}px;
  background-color: ${({theme}) => theme.colors.background};
  justify-content: center;
  align-items: center;
  margin-bottom: ${RFValue(20)}px;
  border-radius: ${RFValue(16)}px;
`;

export const Icon = styled(Feather)`
  font-size: ${RFValue(24)}px;
  color: ${({theme}) => theme.colors.red};
`;

export const Title = styled.Text`
  text-align: center;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(14)}px;
  margin-bottom: ${RFValue(6)}px;
`;

export const ContentHeader = styled.View`
  border-bottom-width: 1px;
  margin: 0 -24px;
  padding: 0 24px;
  border-bottom-color: ${({theme}) => theme.colors.border};
  padding-bottom: ${RFValue(20)}px;
  margin-top: -${RFPercentage(6)}px;
`;

export const ViewUsersContainer = styled.View`
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: ${RFValue(12)}px;
`;

export const InfoText = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;
  margin-bottom: ${RFValue(12)}px;
  text-align: center;
`;

export const LinkTitle = styled.Text`
  text-align: center;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
  margin-bottom: ${RFValue(12)}px;
`;

export const CodeArea = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  height: ${RFValue(40)}px;

  border-style: dashed;
  border-color: ${({theme}) => theme.colors.border};
  border-width: 2px;
  border-radius: ${RFValue(12)}px;

  padding: 0 24px;
`;

export const Code = styled.Text`
  flex: 1;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
  text-align: center;
`;

export const CopyCodeButton = styled.TouchableOpacity``;

export const CopyCodeIcon = styled(Feather)`
  color: ${({theme}) => theme.colors.blue};
  font-size: ${RFValue(14)}px;
`;

export const Section = styled.ScrollView`
  padding: 0 24px;
  margin: 0 -24px;
  padding-top: ${RFValue(20)}px;
`;

export const List = styled.View`
  flex: 1;
`;

export const SectionHeader = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${RFValue(12)}px;
`;

export const SectionTitle = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(14)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const Footer = styled.View`
  padding: 0 24px;
  margin-top: ${RFValue(6)}px;
  padding-bottom: ${Platform.OS === 'ios' && getBottomSpace()
    ? 0
    : RFValue(20)}px;
`;


export const HelpVideoContainer = styled.TouchableOpacity`
  width: 100%;
  justify-content: flex-end;
  height: ${RFPercentage(35)}px;
`;

//@ts-ignore
export const HelpVideoThumb = styled(FastImage)`
  width: 100%;
  height: 100%;
`;

export const VideoInfos = styled.View`
  position: absolute;
  bottom: ${RFValue(32)}px;
  padding: 0 24px;
`;
export const HelpVideoTitle = styled.Text`
  font-size: ${RFValue(14)}px;
  margin-top: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.shape};
`;

export const HelpVideoSubtitle = styled.Text`
  font-size: ${RFValue(12)}px;

  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.shape};
`;